import { Action, Dispatch } from "redux";
import { IState, IAppParams } from "../models";
import { fetchDisclaimers } from "../data";
import { getViewFundList, groupBy } from "../utils";
import * as constants from "./constants";

export function getDisclaimers(appParams: IAppParams) {
	return async (dispatch: Dispatch<IState>, getState: () => IState) => {
		let response: any[];
		let responseAction = { type: constants.GET_DISCLAIMERS };
		let fundlist = getViewFundList(appParams);

		response = await fetchDisclaimers();
		let filteredDisclaimers = response["data"]
			.filter(disclaimer => fundlist === disclaimer.linkedList)
			.map(item => {
				item["disclaimerType"] = item["disclaimerType"].toLowerCase();
				return item;
			});

		let groupedDisclaimers = groupBy(filteredDisclaimers, (disclaimer) => disclaimer["disclaimerType"]);
		if (response["error"]) {
			responseAction["error"] = response["error"];
		}
		else {
			responseAction["payload"] = groupedDisclaimers;
		}

		dispatch(responseAction);
	};
}



// WEBPACK FOOTER //
// ./src/client/actions/disclaimers.ts